export const initialState = {
	surveyGuidMaps: {
		isSyncing: {},
		isUnsyncing: {},
		isDeleting: {},
		isQueuedForDelete: {},
		isSelected: {},
		errorMessages: {},
	},
};

export default initialState;
